export const DEFAULT_GOOGLE_ADS_SCOPES = [
  'https://www.googleapis.com/auth/adwords',
];

export const getGoogleUrl = (from: string, reqId: string, scopes: string[]) => {
  const rootUrl = 'https://accounts.google.com/o/oauth2/v2/auth';

  const options = {
    redirect_uri: import.meta.env.VITE_GOOGLE_OAUTH_REDIRECT_URI as string,
    client_id: import.meta.env.VITE_GOOGLE_OAUTH_CLIENT_ID as string,
    access_type: 'offline',
    response_type: 'code',
    prompt: 'consent',
    scope: scopes.join(' '),
    state: JSON.stringify({ from, id: reqId }),
  };

  const qs = new URLSearchParams(options);

  return `${rootUrl}?${qs.toString()}`;
};

export const DEFAULT_FACEBOOK_ADS_SCOPES = [
  'ads_read',
  'public_profile',
  'business_management',
];

export const getFacebookUrl = (
  from: string,
  reqId: string,
  scopes: string[],
) => {
  const rootUrl = 'https://www.facebook.com/v16.0/dialog/oauth';

  const options = {
    redirect_uri: import.meta.env.VITE_FACEBOOK_OAUTH_REDIRECT_URI as string,
    client_id: import.meta.env.VITE_FACEBOOK_OAUTH_APP_ID as string,
    access_type: 'offline',
    response_type: 'code',
    // prompt: 'consent',
    scope: scopes.join(' '),
    state: JSON.stringify({ from, id: reqId }),
  };

  const qs = new URLSearchParams(options);

  return `${rootUrl}?${qs.toString()}`;
};

// HubSpot OAuth

export const HUBSPOT_REQUIRED_SCOPES = [
  'oauth',
  'crm.objects.contacts.write',
  'crm.schemas.contacts.read',
];

// export const HUBSPOT_OPTIONAL_SCOPES = [
//   'crm.objects.contacts.read',
//   'crm.objects.companies.read',
//   'crm.objects.companies.write',
//   'crm.schemas.companies.read',
//   'crm.objects.deals.read',
//   'crm.objects.deals.write',
//   'crm.schemas.deals.read',
//   'crm.lists.read',
//   'crm.lists.write',
// ];

export const getHubSpotUrl = (reqId: string) => {
  const rootUrl = 'https://app.hubspot.com/oauth/authorize';
  const redirectUri = import.meta.env.VITE_HUBSPOT_OAUTH_REDIRECT_URI as string;
  const clientId = import.meta.env.VITE_HUBSPOT_CLIENT_ID as string;

  const options = {
    client_id: clientId,
    redirect_uri: redirectUri,
    scope: HUBSPOT_REQUIRED_SCOPES.join(' '),
    // optional_scope: HUBSPOT_OPTIONAL_SCOPES.join(' '),
    state: reqId,
  };

  const qs = new URLSearchParams(options);

  return `${rootUrl}?${qs.toString()}`;
};
